var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v(" demo1 ")]),_c('p',[_vm._v(" demo展示: ")]),_c('div',{ref:"container",staticClass:"container"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("文档："),_c('a',{attrs:{"href":"https://site.logic-flow.cn/tutorial/get-started/"}},[_vm._v("https://site.logic-flow.cn/tutorial/get-started/")])])
}]

export { render, staticRenderFns }